<template>
  <div>
    <div class="function">
      <div class="function-num">{{idx+1}}</div>
      <div class="handel-button">
        <el-button
          type="primary"
          icon="el-icon-plus"
          circle
          size="mini"
          class="add-function"
          @click="addFunction"
          v-if="idx===length-1"
        ></el-button>
        <el-button
          type="danger"
          icon="el-icon-minus"
          circle
          size="mini"
          class="remove-function"
          @click="removeFunction(comFunction.tempId)"
          v-if="length>1"
        ></el-button>
      </div>
      <el-row :gutter="10" type="flex" align="middle" style="margin-bottom:15px;">
        <el-col :span="4" style="text-align:center">职能模块</el-col>
        <el-col :span="8" style="display:flex;align-items:center">
          <!-- <el-autocomplete
            size="mini"
            placeholder="输入职能模块"
            v-model="comFunction.职能模块"
            :fetch-suggestions="funcQuerySearch"
            @input="functionChange"
            style='margin-right:5px;'
          ></el-autocomplete>-->
          <el-select
            v-model="comFunction.职能模块"
            size="mini"
            placeholder="输入职能模块"
            filterable
            popper-class="custom-select"
            style="margin-right:5px"
          >
            <el-option :value="item.名称" v-for="(item,idx) in funcData" :key="idx"></el-option>
            <el-button
              type="primary"
              plain
              style="width:100%;position:absolute;bottom:0;left:0"
              @click="createFunction"
            >点击新增职能模块</el-button>
            <div slot="empty">
              <div
                style="font-size:16px;line-height:40px;height:40px;text-align:center;color:#999"
              >暂无数据</div>
              <!-- <el-button type="primary" plain style="width:100%" @click="createFunction">点击新增职能模块</el-button> -->
            </div>
          </el-select>
          <el-link icon="el-icon-question" type="primary" @click="moreFunction" :underline="false"></el-link>
        </el-col>
        <el-col :span="4" style="text-align:center">擅长方向</el-col>
        <el-col :span="8">
          <el-select
            v-model="comFunction.擅长方向"
            size="mini"
            placeholder="下拉选择,可多选"
            filterable
            multiple
            popper-class="custom-select"
          >
            <el-option :value="item.value" v-for="(item,idx) in goodAtData" :key="idx"></el-option>
            <el-button
              type="primary"
              plain
              style="width:100%;position:absolute;bottom:0;left:0"
              @click="createFunction"
            >点击新增擅长方向</el-button>
            <div slot="empty">
              <div
                style="font-size:16px;line-height:40px;height:40px;text-align:center;color:#999"
              >暂无数据</div>
              <!-- <el-button type="primary" plain style="width:100%" @click="createFunction">点击新增擅长方向</el-button> -->
            </div>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="10" type="flex" align="middle">
        <el-col :span="4" style="text-align:center">细分职能</el-col>
        <el-col :span="8">
          <el-select
            v-model="comFunction.细分职能"
            size="mini"
            placeholder="下拉选择,可多选"
            filterable
            multiple
            popper-class="custom-select"
          >
            <el-option :value="item.value" v-for="(item,idx) in detailFuncData" :key="idx"></el-option>
            <el-button
              type="primary"
              plain
              style="width:100%;position:absolute;bottom:0;left:0"
              @click="createFunction"
            >点击新增细分职能</el-button>
            <div slot="empty">
              <div
                style="font-size:16px;line-height:40px;height:40px;text-align:center;color:#999"
              >暂无数据</div>
              <!-- <el-button type="primary" plain style="width:100%" @click="createFunction">点击新增细分职能</el-button> -->
            </div>
          </el-select>
        </el-col>
        <el-col :span="4" style="text-align:center">目标行业</el-col>
        <el-col :span="8">
          <el-select
            v-model="comFunction.目标行业"
            size="mini"
            placeholder="下拉选择,可多选"
            filterable
            multiple
          >
            <el-option :value="item" v-for="(item,idx) in industries" :key="idx"></el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>
    <selectFunction ref="selectFunction" :single="true" @confirm="confirmFunction"></selectFunction>
    <createFunction ref="createFunction" @confirmCreate="confirmCreate"></createFunction>
  </div>
</template>
<script>

import selectFunction from "../../../../company/src/hunting/selectFunction.vue"
import createFunction from "../../../../company/src/hunting/createFunction.vue"
export default {
  components: {
    selectFunction,
    createFunction
  },
  data () {
    return {
      comFunction: this.functions,
      industries: app.industries || [],
      funcData: app.categories || []
    }
  },
  computed: {
    goodAtData () {
      if (!this.comFunction.职能模块 || !app.categories.filter(val => val.名称 === this.comFunction.职能模块)[0]) {
        return []
      }
      const results = app.categories.filter(val => val.名称 === this.comFunction.职能模块)[0].擅长方向.map(val => ({ value: val }))
      return results
    },
    detailFuncData () {
      if (!this.comFunction.职能模块 || !app.categories.filter(val => val.名称 === this.comFunction.职能模块)[0]) {
        return []
      }
      const results = app.categories.filter(val => val.名称 === this.comFunction.职能模块)[0].二级职能.map(val => ({ value: val }))
      return results
    },
  },
  async mounted () {
    if (!this.funcData || this.funcData.length === 0) {
      await app.getCats()
      this.funcData=app.categories
    }
  },
  props: { functions: { type: Object, default: () => ({}) }, idx: { type: Number }, length: { type: Number } },
  methods: {
    createFunction () {
      this.$refs.createFunction.open()
    },
    confirmCreate (data) {
      this.comFunction = data
    },
    moreFunction () {
      this.$refs.selectFunction.open()
    },
    confirmFunction (functions) {
      this.comFunction.职能模块 = functions[0]
    },
    functionChange () {
      this.comFunction.细分职能 = []
      this.comFunction.擅长方向 = []
    },
    funcQuerySearch: async function (queryString, cb) {
      const list = await app.categories.map(cate => cate['名称'])
      const results = (queryString != null ? list.filter(this.funcCreateFilter(queryString)) : list).map(val => ({ value: val }))
      return cb(results)
    },
    funcCreateFilter: function (queryString) {
      return func => func.indexOf(queryString) === 0
    },
    // goodAtData () {
    //   if (!this.comFunction.职能模块) {
    //     return [{ value: "请先选择职能模块" }]
    //   }
    //   const results = app.categories.filter(val => val.名称 === this.comFunction.职能模块)[0].擅长方向.map(val => ({ value: val }))
    //   if (results.length === 0) {
    //     return [{ value: "点击快速新建擅长方向" }]
    //   }
    //   console.log(results)
    //   return results
    // },
    // detailFuncData () {
    //   if (!this.comFunction.职能模块) {
    //     return [{ value: "请先选择职能模块" }]
    //   }
    //   const results = app.categories.filter(val => val.名称 === this.comFunction.职能模块)[0].二级职能.map(val => ({ value: val }))
    //   if (results.length === 0) {
    //     return [{ value: "点击快速新建二级职能" }]
    //   }
    //   console.log(results)
    //   return results
    // },
    addFunction () {
      this.$emit("addFunction", {})
    },
    removeFunction () {
      console.log(this.comFunction)
      this.$emit("removeFunction", { tempId: this.comFunction.tempId })
    }
  }
}
</script>
<style scoped>
.function {
  width: 800px;
  position: relative;
  padding: 15px;
  /* border: 1px dashed #ff6600; */
  margin: 12px 0;
  border-radius: 8px;
}
.info {
  width: 800px;
  padding: 0 15px;
}
.function-num {
  position: absolute;
  left: -12px;
  top: -12px;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: #ffcc00;
  border-radius: 50%;
  display: none;
}
.handel-button {
  width: 60px;
  /* display: flex; */
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 36px;
  right: -70px;
  display: none;
}
.custom-select .el-select-dropdown__list {
  padding-bottom: 45px !important;
}
</style>
